<template>
  <div class="not-found">
    <div class="wrap">
      <div class="pic"></div>
      <div class="right-region">
        <div>404</div>
        <div>抱歉，你访问的页面不存在</div>
        <router-link to="/">
          <el-button type="primary">返回首页</el-button>
        </router-link>
      </div>
    </div>
    <div class="copyright">
      <span>腾讯计算机系统有限公司</span>
      <span>Copyright © 1998-2020 Tencent. All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';

  .not-found {
    overflow: hidden;
    position: relative;
    .wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10%;
      .pic {
        .setImg('/not-found/pic.png');
      }
      .right-region {
        margin-left: 40px;
        div {
          &:nth-of-type(1) {
            font-size: 90px;
            font-weight: bold;
          }
          &:nth-of-type(2) {
            font-size: 20px;
            color: @color-text-3;
            margin-bottom: 16px;
          }
        }
      }
    }
  }
</style>